import { createContext } from "react"

export interface IThemeContext {
	readonly colors: {
		readonly green: string[]
		readonly red: string[]
		readonly dark: string[]
		readonly gray: string[]
		readonly white: string[]
	}
	readonly fonts: {
		readonly primary: string
	}
}

export const DEFAULT_THEME: IThemeContext = {
	colors: {
		green: ["#16C706"],
		red: ["#C70606"],
		dark: ["#000"],
		gray: ["#FAFAFA", "#F0F0F0", "#747474", "#636363"],
		white: ["#FFF"],
	},
	fonts: {
		primary: "Inter",
	},
}

export const ThemeContext = createContext<IThemeContext>(DEFAULT_THEME)
